<ng-template #volumeBarMaxTextTpl>
	<p>100</p>
</ng-template>

<div class="w-100 h-100 fl fl-dir-c fl-ai-fs fl-jc-fs" #videoWrapper>
	<div class="w-100 h-0 ov-h fl fl-ai-c fl-jc-fs">
		<div #volumeBarMaxText>
			<ng-container [ngTemplateOutlet]="volumeBarMaxTextTpl"></ng-container>
		</div>
	</div>

	<div
		class="media-wrapper w-100 h-100 pos-rel ov-h"
		style="background-color: #000000;"
		[class.allow-hover]="!$hideMouse()"
		[class.show-controls]="$showControls()"
		[style.cursor]="$hideMouse() ? 'none' : null"
		(click)="$event.stopPropagation(); $event.preventDefault(); togglePlay()"
		(dblclick)="$event.stopPropagation(); $event.preventDefault(); toggleFullscreen()"
		(keydown.Space)="$event.stopPropagation(); $event.preventDefault(); togglePlay()"
		(keydown.enter)="$event.stopPropagation(); $event.preventDefault(); togglePlay()"
		(keydown.f)="$event.stopPropagation(); $event.preventDefault(); toggleFullscreen()"
		(keydown.m)="$event.stopPropagation(); $event.preventDefault(); toggleMute()"
		(keydown.arrowUp)="$event.stopPropagation(); $event.preventDefault(); increaseVolume()"
		(keydown.arrowDown)="$event.stopPropagation(); $event.preventDefault(); decreaseVolume()"
		(keydown.arrowLeft)="$event.stopPropagation(); $event.preventDefault(); goBackwards()"
		(keydown.arrowRight)="$event.stopPropagation(); $event.preventDefault(); goForward()"
		(mousemove)="onMouseMove()"
		(mouseleave)="onMouseLeave()"
	>
		<video
			#video
			class="w-100 h-100"
			[src]="$fileUrl()"
			loop
			crossorigin="use-credentials"
			(pause)="onPause()"
			(play)="onPlay()"
			(ended)="onEnded()"
			(onloadedmetadata)="onLoadedMetadata()"
			(durationchange)="onDurationChange()"
			(timeupdate)="onTimeUpdate()"
			(volumechange)="onVolumeChange()"
		></video>

		<div
			class="controls-bar pos-abs pos-l-0 pos-b-0 w-100 p-3-rl p-2-tb fl fl-ai-c fl-jc-c fl-gap-2"
			(click)="$event.stopPropagation()"
		>
			<div class="fl-fixed fl fl-ai-c fl-jc-fs fl-gap-0h">
				<button commonButtonIcon class="action-button" (click)="togglePlay()">
					<i
						[class.icon-bold-play-media]="!$playing()"
						[class.icon-bold-pause-media]="$playing()"
					></i>
				</button>

				<button commonButtonIcon class="action-button" (click)="goBackwards()">
					<i class="icon-bold-backward-media"></i>
				</button>

				<button commonButtonIcon class="action-button" (click)="goForward()">
					<i class="icon-bold-forward-media"></i>
				</button>

				<div
					class="fl fl-ai-c fl-jc-fs volume-wrapper"
					[class.show-content]="$draggingVolume()"
					[class.allow-hover]="!$draggingTime()"
					[style.--aux-volume-width.px]="volumeBarMaxText.clientWidth"
				>
					<button commonButtonIcon class="action-button" (click)="toggleMute()">
						<i [class.icon-volume]="!$muted()" [class.icon-volume-muted]="$muted()"></i>
					</button>

					<div class="fl fl-ai-c fl-jc-fs volume-content ov-h">
						<div class="fl-fixed fl fl-ai-c fl-jc-fs fl-gap-1">
							<div
								#volumeBar
								class="pos-rel h-sp-0h br-0q fl-fixed fl fl-ai-c fl-jc-fs line-230-as-bg cursor-pointer"
								style="width: calc(10 * var(--spacing))"
							>
								<div
									class="h-100 br-0q bg-primary"
									[style.width.%]="$volumeToShow()"
								></div>

								<div
									class="pos-abs h-sp-1t w-sp-1t br-circle bg-primary pe-none"
									style="top: 50%; transform: translate(-50%, -50%)"
									[style.left.%]="$volumeToShow()"
								></div>
							</div>

							<div class="fl-fixed fl fl-dir-c fl-ai-fs fl-jc-fs">
								<div class="h-0 ov-h invisible">
									<ng-container
										[ngTemplateOutlet]="volumeBarMaxTextTpl"
									></ng-container>
								</div>
								<p>{{ $volumeToShow() | number : '1.0-0' }}</p>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div
				#timerBar
				class="fl-adaptable h-sp-0t ov-h cursor-pointer"
				style="
					background-color: rgb(78, 79, 85);
					border-radius: calc(0.5 * 0.75 * var(--spacing));
				"
			>
				<div
					class="h-100 bg-primary"
					[style.width.%]="($currentTime() / $maxTime()) * 100"
					style="border-radius: calc(0.5 * 0.75 * var(--spacing))"
				></div>
			</div>

			<p class="fl-fixed">
				<span>{{ $currentTime() | videoPreviewTimestamp }}</span>
				<span>&nbsp;/&nbsp;</span>
				<span>{{ $maxTime() | videoPreviewTimestamp }}</span>
			</p>

			<div class="fl-fixed fl fl-ai-c fl-jc-fs fl-gap-0h">
				<button commonButtonIcon class="action-button" (click)="toggleFullscreen()">
					@if ($fullscreenEnabled()) {
						<i class="icon-fullscreen-inside"></i>
					} @else {
						<i class="icon-fullscreen-outside"></i>
					}
				</button>
			</div>
		</div>
	</div>
</div>
